/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import G17Client from '@services/G17Client';
import { Scorecard, ScorecardGoal } from '../../types/scorecard';
import { HistoricalReportData, ReportData, ReportOptions } from '../../types/reportData';
import { DownloadMultiScope } from '../../types/download';
import { SurveyModelMinimalUtrv } from '@g17eco/types/survey';

export interface SDGReportGoal {
  goal: string,
  metricsIncluded: ReportData[],
  contribution: ScorecardGoal,
  standardsOrFrameworks: string[],
  statusSummary: {
    total: number,
    completed: number,
    verified: number,
    evidenced: number,
    na: number,
    nr: number,
  }
}

export interface SDGReport {
  materiality: {
    [key: number]: number
  },
  contribution: Scorecard,
  goals: SDGReportGoal[]
}

export const reportMultiScopeData = async (
  surveyId: string,
  downloadScope: DownloadMultiScope
): Promise<ReportData[]> => {
  return G17Client.post(`surveys/${surveyId}/report`, downloadScope).then((response) => response.data.data);
};

export const reportDataWithHistoryScope = async (surveyId: string, downloadScope: DownloadMultiScope): Promise<{ historical: HistoricalReportData[], targets: SurveyModelMinimalUtrv[]  }> => {
  return G17Client
    .post(`surveys/${surveyId}/report/historical`, downloadScope)
    .then((response) => response.data.data);
};

export const sdgReportData = async (surveyId: string,options?: ReportOptions): Promise<SDGReport> => {
  return G17Client
    .get(`surveys/${surveyId}/report/sdg`, {
      params: { ...(options || {}) },
    })
    .then((response) => response.data.data);
};
